<!-- eslint-disable max-len -->
<template>
  <div class="component-card">
    <div class="container-top-admin">
      <div class="m__b--20 m__l--20">
        <i
          class="fa fa-arrow-left fa-lg cursor-pointer p__t--3"
          @click="$router.push('/buku-saku-siswa')"/>
        <!-- <div class="top-label-admin"> {{ $route.params.tahunajaran.replace('-', '/') }} </div>
        <i class="fa fa-angle-right fa-lg cursor-pointer p__t--3 m__l--5"/>
        <div class="label-tahun-ajaran"> {{ dataKelas ? dataKelas.name : '' }} </div> -->
        <div class="top-label-admin font-gotham-bold">
          Buku Saku Siswa <br>
          <span class="top-span-admin font-gotham-bold">
            {{ $route.params.tahunajaran.replace('-', '/') }}
            <i class="fa fa-angle-right fa-lg cursor-pointer p__t--3 m__l--5"/>
            {{ data_kelas ? data_kelas.name : '' }}
            <i class="fa fa-angle-right fa-lg cursor-pointer p__t--3 m__l--5"/>
            {{ data_siswa ? data_siswa.nama_siswa : '' }}
          </span>
        </div>
      </div>

      <div class="d-flex">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'prestasi'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="tabSelected = 'prestasi'">
          PRESTASI
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'pelanggaran'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="tabSelected = 'pelanggaran'">
          PELANGGARAN
        </div>
      </div>
    </div>

    <div class="m__t--45">
      <j-prestasi v-if="tabSelected === 'prestasi'" />
      <j-pelanggaran v-if="tabSelected === 'pelanggaran'" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

import jPrestasi from '@/views/kesiswaan/buku-saku/tab-component/jPrestasi';
import jPelanggaran from '@/views/kesiswaan/buku-saku/tab-component/jPelanggaran';

export default {
  components: {
    jPrestasi,
    jPelanggaran,
  },
  data() {
    return {
      tabSelected: 'prestasi',
      data_siswa: null,
      data_kelas: null,
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    const params = {
      pagination: {
        query: this.$route.params.nis,
        query_type: 'nis',
      },
    };
    this.getListSiswa(params).then((res) => {
      this.data_siswa = res.data.data[0];
    });

    const paramsKelas = {
      pagination: {
        query: '',
        query_type: 'kode_kelas',
      },
    };
    this.getListKelasAll(paramsKelas).then((res) => {
      this.data_kelas = res.data.data.find(f => f.kode === this.$route.params.kelas);
    });
  },
  methods: {
    ...mapActions('jStoreKesiswaan', ['getListSiswa', 'getListKelasAll']),
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/buku-saku/jBukuSakuForm.vue